"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDisableBodyScroll = void 0;

var _react = require("react");

var _utils = require("../utils");

var setDocumentOverflow = function setDocumentOverflow(value) {
  if ((0, _utils.windowGlobal)()) {
    document.documentElement.style.overflow = value;
  }
};

var useDisableBodyScroll = function useDisableBodyScroll(open) {
  (0, _react.useEffect)(function () {
    if (open) {
      setDocumentOverflow('hidden');
    } else {
      setDocumentOverflow('unset');
    }

    return function () {
      return setDocumentOverflow('unset');
    };
  }, [open]);
};

exports.useDisableBodyScroll = useDisableBodyScroll;